import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import { useManualState } from './Provider';
import * as action from './store/Document.action';
import { CloseIcon, TickIcon } from '../../bombiix-icon';

function UploadFolder({ onOpen, toggle }) {
  const { state, setState } = useManualState();
  const { t } = useTranslation('common');

  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);

  const {
    DocumentReducer: { fileDataById },
  } = reducer;

  // Local state for form data
  const [formData, setFormData] = useState({
    folderName: '',
  });

  const [folderId, setFolderId] = useState(null);
  useEffect(() => {
    const documentData = JSON.parse(localStorage.getItem('manualDoumentFolder')) || {};
    if (documentData._id) {
      setFolderId(documentData._id);
    }
  }, []);

  useEffect(() => {
    if (fileDataById) {
      setFormData((prevState) => ({
        ...prevState,
        folderName: fileDataById?.documentTitle,
      }));
    }
  }, [fileDataById]);

  const [errors, setErrors] = useState({}); // State for validation errors

  const validateForm = () => {
    const newErrors = {};
    if (!formData.folderName.trim()) {
      newErrors.folderName = 'Document Title is required.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleInputChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      folderName: e?.target?.value,
    }));
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    let res = null;
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    if (state?.isEditFolder) {
      const obj = {
        documentTitle: formData?.folderName,
        _id: fileDataById?._id,
        type: 'folder',
      };

      res = await dispatch(action.updateManualDocument(obj, t));
    } else {
      const obj = {
        documentTitle: formData?.folderName,
        type: 'folder',
        folderId: folderId || null,
      };

      res = await dispatch(action.saveManualDocument({ formData: obj, type: 'folder' }, t));
    }
    if (res) {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
    if (res?.code === 200) {
      setFormData((prev) => ({
        ...prev,
        folderName: '',
      }));
      toggle();
    }
  };

  return (
    <Modal
      show={onOpen}
      size="md"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      className="common-custom-modal modal-medium"
      onHide={toggle}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"> {state?.isEditFolder ? 'Rename Folder' : 'Add Folder'}</Modal.Title>
        <CloseIcon size={28} onClick={toggle} className="cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          <div className="input-group form-floating-label fixed-label">
            <input
              type="text"
              name="folderName"
              autoComplete="off"
              maxLength={30}
              value={formData?.folderName}
              onChange={handleInputChange}
              placeholder={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.ENTER_NAME')}
              className="form-control"
            />
            <label className="asterisk-req" />
          </div>
          {errors?.folderName && <span style={{ color: 'red', marginTop: '5px' }}>{t('MANUAL_DOCUMENTS.FOLDER_NAME_REQUIRED')}</span>}
          <span className="character-counter">{formData?.folderName?.length || 0}/30</span>
        </div>
        <div className="common-model-footer">
          <button aria-label="save" onClick={() => handleSubmit()} type="button" className="btn p-0">
            <TickIcon size={28} />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UploadFolder;
